/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-11
 *
 **/

import FormData from 'form-data'

/**
 * Validate curp from WS
 * @param curp
 * @returns {boolean}
 */
const validateCURP = (curp) => {
    return  curp != null && curp.length == 18
}

/**
 * Converts JSON Object to axios FormFata
 * @param jsonObject
 * @returns {FormData}
 */
const toFormData = (jsonObject) => {
    let data = new FormData()
    for (let key in jsonObject){
        data.append(key, jsonObject[key])
    }

    return data
}

/**
 * Convierte el request Json a un formato para mandar a las acciones de carrito (posrtafolio)
 * transforma el json en texto y lo agrega al campo data del formulario
 *
 * @param jsonObject
 * @returns {FormData}
 */
const toFormDataForCart = (jsonObject) => {
    let data = new FormData()
    data.append('data', JSON.stringify(jsonObject))

    return data
}

/**
 * Compares timeToCompare with today time,  if timeToCompare is greater than today so is expired
 * @param timeToCompare
 */
const isDateExpired = (timeToCompare) => {
    let today = new Date();
    return today.getTime() > timeToCompare
}

/**
 * Get a time starting today and increments seconds parameters
 * @param seconds
 */
const createTimeWithIncrement = (seconds) => {
    let today = new Date()

    return (today.getTime() + (seconds*1000))
}

/**
 * Parse response of google auth and return user profile data
 */
const parsedGoogleUserData = (googleUser) => {
    //let profile = googleUser.getBasicProfile()
    /*let googleProfile = {
        id: `go_${googleUser.Ca}`,
        email: profile.Wt,
        names: profile.dV,
        lastname: profile.fT,
        access_token: googleUser.wc.access_token,
        icon: profile.JJ
    }*/

    // console.log(JSON.stringify(googleUser))

    let googleProfile = {
        id: `go_${googleUser.Aa}`,
        email: googleUser.Ys.It,
        names: googleUser.Ys.hU,
        lastname: googleUser.Ys.dS,
        access_token: googleUser.mc.access_token,
        icon: googleUser.Ys.gJ
    }

    return googleProfile
}

/**
 * Parse response of google auth and return user profile data
 */
const parsedFacebookUserData = (facebookUser) => {
    let googleProfile = {
        id: `fb_${facebookUser.id}`,
        email: facebookUser.email,
        names: facebookUser.first_name,
        lastname: facebookUser.last_name,
        icon: facebookUser.picture.data.url
    }

    return googleProfile
}

/**
 * Create password automatically when login or register via google or facebook
 */
const createStrongPassword = (data1, data2) => {
    //TODO: mover a security y aplicar una encryptacion
    return `${data1}.${data2}`
}

const bootstrapSizeToVuetify = (bootstrapSize, vuetifySize) =>{
    let sizes = {xs: 0, sm: 0, md: 0, lg: 0}
    let arrayClasses =  bootstrapSize.split(' ')

    for (let i=0; i<arrayClasses.length; i++){
        if (arrayClasses[i].includes('col-xs-')){
            sizes.xs = parseInt(arrayClasses[i].replace('col-xs-', ''))
        }else if (arrayClasses[i].includes('col-sm-')){
            sizes.sm = parseInt(arrayClasses[i].replace('col-sm-', ''))
        }else if (arrayClasses[i].includes('col-md-')){
            sizes.md = parseInt(arrayClasses[i].replace('col-md-', ''))
        }else if (arrayClasses[i].includes('col-lg-')){
            sizes.lg = parseInt(arrayClasses[i].replace('col-lg-', ''))
        }
    }

    if (sizes.xs === 0) { sizes.xs = 12}
    if (sizes.sm === 0) { sizes.sm = sizes.xs}
    if (sizes.md === 0) { sizes.md = sizes.sm}
    if (sizes.lg === 0) { sizes.lg = sizes.md}

    return sizes[vuetifySize];
}

/**
 * Converte un expresion en modo text a un array parseado por los operadores
 * @param expresion
 */
const expresionToArray = (expression) => {
    return expression.split('==').join(',').split('!=').join(',').split('&&').join(',').split('||').join(',').split(',')
}

const capitalizeWord = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1)
}


export {
    validateCURP,
    toFormData,
    isDateExpired,
    createTimeWithIncrement,
    parsedGoogleUserData,
    parsedFacebookUserData,
    createStrongPassword,
    capitalizeWord,
    bootstrapSizeToVuetify,
    expresionToArray,
    toFormDataForCart
}